const SAFE_PROTOCOLS = new Set(['http:', 'https:', 'mailto:', 'tel:']);

export function toSafeNavigationUrl(rawUrl: string | undefined | null): string | null {
  if (!rawUrl) return null;
  const trimmed = rawUrl.trim();
  if (!trimmed) return null;

  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    const parsed = new URL(trimmed, base);
    if (!SAFE_PROTOCOLS.has(parsed.protocol)) return null;

    if (parsed.origin === base && trimmed.startsWith('/')) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    }

    return parsed.toString();
  } catch {
    return null;
  }
}

export function isSafeNonSearchUrl(rawUrl: string | undefined | null): boolean {
  const safeUrl = toSafeNavigationUrl(rawUrl);
  return Boolean(safeUrl && !safeUrl.startsWith('/search'));
}

export function navigateToSafeUrl(rawUrl: string | undefined | null): boolean {
  const safeUrl = toSafeNavigationUrl(rawUrl);
  if (!safeUrl) return false;
  window.location.href = safeUrl;
  return true;
}

export function openSafeUrl(rawUrl: string | undefined | null): boolean {
  const safeUrl = toSafeNavigationUrl(rawUrl);
  if (!safeUrl) return false;
  window.open(safeUrl, '_blank', 'noopener,noreferrer');
  return true;
}
